import { render, staticRenderFns } from "./VerticalScroll.vue?vue&type=template&id=65652348&scoped=true&"
import script from "./VerticalScroll.vue?vue&type=script&lang=ts&"
export * from "./VerticalScroll.vue?vue&type=script&lang=ts&"
import style0 from "./VerticalScroll.vue?vue&type=style&index=0&id=65652348&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65652348",
  null
  
)

export default component.exports